import PropTypes from 'prop-types'
import React from 'react'
import { Box, Flex, Heading, Text, VStack } from '@chakra-ui/react'
// import UnderlineHeading from '../../../components/UnderlineText/UnderlineHeading'
import { useLabels } from '../../../utils/hooks/useLabels/useLabels'
import ButtonSelectorList from '../../../components/ButtonSelectorList/ButtonSelectorList'
import useButtonSelector from '../../../utils/hooks/useButtonSelector/useButtonSelector'
import Factory, { options } from './RequestFactory/Factory'
import UnderLine from '../../../components/UnderLine/UnderLine'

function ViewSeparator({ children }) {
  return <Box>{children}</Box>
}

ViewSeparator.propTypes = {
  children: PropTypes.node,
}
export default function CreateAccount() {
  const { selected, onSelectedChange } = useButtonSelector(options)
  const { texts } = useLabels()
  return (
    <Flex direction="column">
      <ViewSeparator>
        <VStack alignItems="flex-start">
          <Heading variant="h5">{texts.create_account}</Heading>
          <Text variant="body1">
            {texts.create} <b>{texts.nominativeAccounts}</b>{' '}
            {texts.create_account_description}
          </Text>
          <Text variant="body1">
            {texts.theAccounts} <b>{texts.noNominative}</b>{' '}
            {texts.noNominativeCreateDescription}
          </Text>
          <UnderLine />
        </VStack>
        {/* <UnderlineHeading
          text={texts.create_account}
          variant="h5"
          subtext={texts.create_account_description}
          subVariant="body1"
        /> */}
      </ViewSeparator>
      <ViewSeparator>
        <Heading variant="h5">{texts.select_account_type}</Heading>
        <Box mt="40px" />
        <ButtonSelectorList
          options={options}
          onSelectedChange={onSelectedChange}
          selected={selected}
          stackProps={{ spacing: '74px' }}
        />
      </ViewSeparator>
      <ViewSeparator>
        <Factory request={selected?.label} />
      </ViewSeparator>
    </Flex>
  )
}
